










































































































































































import _ from 'lodash';
import { editFactory } from '@/main/pages';
import { Vozidlo } from '@/modules/kartoteka/vozidlo';
import { Partner } from '@/modules/kartoteka/partner';
import { apiProvider as ozakazkaApiProvider } from '@/modules/servis/ozakazka/api';
import { openEdit } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';
import { NAME as ZAKAZKA_NAME, ZAKAZKA_DRUH, ZAKAZKA_DRUH_LOCALIZED } from '@/modules/servis/zakazka/constants';
import { getColumnsRowMapObject } from '@/main/utils/table';
import { previewButton, saveButton } from '@/main/utils/tableOperations';
import { TABLE_DATA } from '@/main/store/listEditTypes';
import { forceFileDownload } from '@/main/utils/fileHelper';
import { WatchlistApproval } from '@/modules/administrace/watchlistApproval';
import { EMAIL_TYP_PZN } from '@/modules/kartoteka/smsEmailModal/constants';
import { LAST_ODOMETER } from '@/main/store/constants';

import DmsPdfDialog from '#components/DmsPdfDialog.vue';

import CheckboxCard from './components/CheckboxCard.vue';
import { NAME, MERGE_VOZIDLO, MERGE_ZAKAZNIK, PHOTO_LIST, PENDING_JOB_LIST, MENU_CODE, TAB_NAMES, TABS } from './constants';
import { store } from './store/edit';
import { editMutations, actions } from './store/types';
import { apiProvider } from './api';

export default editFactory(NAME, store).extend({
	components: {
		VozidloSelect: Vozidlo.components.Select,
		PartnerSelect: Partner.components.Select,
		CheckboxCard,
		DmsPdfDialog,
	},
	data() {
		return {
			notificationFlag: false,
			firstVisitDialog: {
				visible: false,
				title: null as string | null,
				notificationDialogMsg: null as string | null,
			},
			dependencies: [MERGE_ZAKAZNIK, MERGE_VOZIDLO, PHOTO_LIST, PENDING_JOB_LIST],
			fileList: [] as any[],
			showDruhZakazkyDialog: false,
			zakazkaDruh: ZAKAZKA_DRUH.DILENSKA,
			palivoStavMarks: {
				0: '0/R',
				1: '',
				2: '',
				3: '',
				4: '1/1',
			},
			tiskDialog: { visible: false, provider: null as (() => Promise<any>) | null },
			imgUrl: '' as any,
			showPhotoDialog: false,
			tabNames: TAB_NAMES,
		};
	},
	computed: {
		tabItems() {
			const tabItems = [];

			if (this.hasTabAccess(MENU_CODE, TABS.Stav)) tabItems.push(TAB_NAMES.STAV);
			if (this.hasTabAccess(MENU_CODE, TABS.Fotografie)) tabItems.push(TAB_NAMES.FOTOGRAFIE);
			if (this.hasTabAccess(MENU_CODE, TABS.Poznamka)) tabItems.push(TAB_NAMES.POZNAMKA);
			if (this.hasTabAccess(MENU_CODE, TABS.Opendefect)) tabItems.push(TAB_NAMES.OPENDEFECT);

			return _.pick(TABS, tabItems);
		},
		mutationsMappers(): Record<string, string> {
			return {
				partner: `${this.storeUri}/${editMutations.PARTNER_SELECT_MAPPER}`,
				vozidlo: `${this.storeUri}/${editMutations.VOZIDLO_SELECT_MAPPER}`,

			};
		},
		actionsMapper(): Record<string, string> {
			return {
				actionName: `${this.storeUri}/${actions.VOZIDLO_CHANGE}`,
			};
		},
		partnerSelectFilter(): object {
			return {
				ZakaznikId: this.ZakaznikId,
				ZakaznikKonId: this.ZakaznikkonId,
				Ozakazka: true,
				Create: this.ZakaznikkonId && this.dependentTables.MergeZakaznik.rows.length === 0 && !this.ZakaznikId,
			};
		},
		photoButtons(): Record<string, any> {
			return {
				...saveButton(this.savePhoto),
				...previewButton(this.showPhoto),
			};
		},
		vozidloSelectFilter(): object {
			return {
				VozidloId: this.VozidloId,
				Spz: this.VozidloIdSpz,
				VozidloKonId: this.VozidlokonId,
				ZakaznikId: this.ZakaznikId,
				Ozakazka: true,
				Create: this.VozidlokonId && this.dependentTables.MergeVozidlo.rows.length === 0 && !this.VozidloId,
			};
		},
		zakazkaPrirazena(): boolean {
			return !!this.Zakazky.length;
		},
		visibleCreateZakazka(): boolean {
			return !this.zakazkaPrirazena && this.CheckinId! > 0;
		},
		disabledAddZakazka(): boolean {
			return !this.ZakaznikId || !this.VozidloId;
		},
		disabledStav(): boolean {
			return !!this.MiddlewareCheckinId || this.isViewMode;
		},
		ZakaznikText(): string | null {
			return this.ZakaznikId ? this.ZakaznikIdText : this.ZakaznikkonIdText;
		},
		spzCmp: {
			get(): string | null {
				if (!this.VozidloId) {
					return !this.VozidlokonId ? '' : this.VozidlokonIdSpz;
				}

				return this.VozidloIdSpz!;
			},
			set(value: string | null) {
				this.VozidloIdSpz = value;
			},
		},
		VozidloText(): string | null {
			return this.VozidloId ? this.KaroserieNr : this.VozidlokonIdText;
		},
		druhyZakazkyLocalized(): Record<string, any> {
			const druhy = [ZAKAZKA_DRUH.DILENSKA, ZAKAZKA_DRUH.GARANCE, ZAKAZKA_DRUH.INTERNI_DILENSKA, ZAKAZKA_DRUH.KULANCE];
			return _.pick(ZAKAZKA_DRUH_LOCALIZED, druhy);
		},
		druhZakazkyDialogLabel(): string {
			return this.LocalizeFormular('dlgZakazka');
		},
		finalNotificationText(): string | undefined {
			return this.NotificationMessage?.replace('<B>', '')?.replace('</B>', '');
		},
	},
	methods: {
		async onBlurHandler() {
			if (this.dmsSys.CustomerRevisitPrp) {
				this.startLoading();
				const file = await apiProvider.getRepeatRepairRevisit(this.VozidloId!, this.KmStav!);
				this.endLoading();
				if (file.data.length > 0) {
					this.IsCustRevisit = true;
					const { odoMeter, serviceDate } = file.data;
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('CarDetailInformation').replace(LAST_ODOMETER, `${odoMeter}`).replace('<LAST_SERVICE>', `${serviceDate}`),
						localizeMessage: false,
						title: this.LocalizeChyboveHlasky('infoTitle'),
					});
				}
			}
		},
		async fetchTableData(tablesToFetch?: string[]): Promise<any> {
			let tables: string[] = [];
			if (this.MiddlewareCheckinId) {
				tables = tablesToFetch ?? this.dependencies as string[];
			} else {
				tables = [MERGE_ZAKAZNIK, MERGE_VOZIDLO, PENDING_JOB_LIST];
			}
			return Promise.all(
				_.map(tables, (tableName) => this.$store.dispatch(`${this.storeUri}/${tableName}_${TABLE_DATA}`)),
			);
		},
		sendWatchlistVehicleEmail() {
			const watchlistedInput = {
				ZakaznikId: this.edit.ZakaznikId,
				VozidloId: this.edit.VozidloId,
				emailTypPzn: EMAIL_TYP_PZN.WATCHLISTED_NOTIFICATION,
				IsNotification: true,
				OrderState: this.LocalizeChyboveHlasky('CheckIn'),
			};
			this.WatchlistDialog = false;
			WatchlistApproval.apiProvider.sendEmail(watchlistedInput);
		},
		async savePhoto(e: any, item: any) {
			this.startLoading();
			const mapedRow = getColumnsRowMapObject(this.dependentTables.PhotoList.columns, item) as any;
			const file = await apiProvider.getPhoto(this.MiddlewareCheckinId!, this.PchiObchodnikNr!, mapedRow.PhotoIdx, mapedRow.PhotoType);
			const url = window.URL.createObjectURL(file.data);
			forceFileDownload(url, mapedRow.ID);
			this.endLoading();
		},
		async showPhoto(e: any, item: any) {
			this.startLoading();
			const mapedRow = getColumnsRowMapObject(this.dependentTables.PhotoList.columns, item) as any;
			const file = await apiProvider.getPhoto(this.MiddlewareCheckinId!, this.PchiObchodnikNr!, mapedRow.PhotoIdx, mapedRow.PhotoType);
			this.imgUrl = window.URL.createObjectURL(file.data);
			this.endLoading();
			this.showPhotoDialog = true;
		},
		async openZakazkaDetail() {
			await openEdit(ZAKAZKA_NAME, PageMode.EDIT, { id: this.Zakazky[0].ZakazkaId });
		},
		// TODO: dalsi user story
		ulozFotkyClick() {
			console.log('TODO');
		},
		async vytvorZakazkuClick() {
			this.showDruhZakazkyDialog = true;
		},
		tiskAvytvorZakazkuClick() {
			// TODO: tisk
			this.vytvorZakazkuClick();
		},
		async tiskProtokoluClick() {
			if (this.isModified) {
				const result = await this.save(false);
				if (result instanceof Error) return;
			}
			this.tiskDialog.provider = this.fetchPdfProvider;
			this.tiskDialog.visible = true;
		},
		fetchPdfProvider() {
			return apiProvider.getCheckinReportPdf(this.PchiObchodnikNr!, false, this.MiddlewareCheckinId!);
		},
		async onDruhZakazkyDialogOk() {
			this.WatchlistFlag = true;
			if (this.OzakazkaId) {
				try {
					this.startLoading();
					const { data: zakazkaId } = await apiProvider.propojSeZakazkou(this.CheckinId!, this.OzakazkaId!);
					if (!zakazkaId) {
						try {
							this.startLoading();
							const createdZakazkaId = (await ozakazkaApiProvider.createZakazka(this.OzakazkaId, false, this.CheckinId!, this.zakazkaDruh)).data;
							await openEdit(ZAKAZKA_NAME, PageMode.EDIT, { id: createdZakazkaId });
						} finally {
							this.endLoading();
						}
					}
				} finally {
					this.endLoading();
				}
			} else {
				await openEdit(ZAKAZKA_NAME, PageMode.CREATE, {
					filter: {
						VozidloId: this.VozidloId,
						ZakaznikId: this.ZakaznikId,
						ZakazkaDruh: this.zakazkaDruh,
						CheckinId: this.CheckinId,
					},
				});
			}
		},
	},
	watch: {
		CustFirstVisitPrp(val) {
			if (val) {
				this.FirstVisitVisible = true;
				this.firstVisitDialog.visible = true;
				this.firstVisitDialog.title = this.LocalizePopisostatni('SystemoveUdaje');
				this.firstVisitDialog.notificationDialogMsg = this.LocalizePopisostatni('CustVisit');
			} else {
				this.FirstVisitVisible = false;
			}
		},
	},
});
